import React from "react";
import { Link } from "react-router-dom";
import { Home, Ghost } from "lucide-react";
import { PageHeader } from "@/components/Layout";

export default function NotFound() {
  return (
    <div>
      <PageHeader overline="Errore 404" title="Pagina non trovata" subtitle="La pagina che cerchi non esiste o è stata spostata." />
      <div className="max-w-xl mx-auto px-4 sm:px-6 py-16 text-center">
        <Ghost size={64} className="mx-auto text-ink-600 mb-6" />
        <p className="text-muted-foreground mb-8">Torna alla home e riparti dalla Challenge.</p>
        <Link to="/" className="btn-gold inline-flex"><Home size={18} /> Torna alla Home</Link>
      </div>
    </div>
  );
}
